import {Button} from '@mantine/core'
import {IconLayoutGrid, IconList} from '@tabler/icons-react'
import type {CSSProperties} from 'react'

import {BOARD_LAYOUT_OPTIONS, type BoardLayout} from './board-layout'
import classes from './board-layout-picker.module.css'

const BOARD_LAYOUT_ICON_STROKE = 2
const SELECTED_ICON_COLOR = 'var(--mantine-color-dark-9)'
const UNSELECTED_ICON_COLOR = 'var(--mantine-color-gray-4)'

const selectedButtonStyle = {
    '--button-bg': 'var(--mantine-color-gray-1)',
    '--button-hover': 'var(--mantine-color-gray-2)',
} as CSSProperties

function boardLayoutIcon(layout: BoardLayout, selected: boolean) {
    const color = selected ? SELECTED_ICON_COLOR : UNSELECTED_ICON_COLOR

    return layout === 'list' ? (
        <IconList size={18} stroke={BOARD_LAYOUT_ICON_STROKE} color={color} />
    ) : (
        <IconLayoutGrid size={18} stroke={BOARD_LAYOUT_ICON_STROKE} color={color} />
    )
}

type BoardLayoutPickerProps = {
    value: BoardLayout
    onChange: (value: BoardLayout) => void
}

export function BoardLayoutPicker({value, onChange}: BoardLayoutPickerProps) {
    return (
        <div role="group" aria-label="Board layout">
            <Button.Group>
                {BOARD_LAYOUT_OPTIONS.map((option) => {
                    const selected = value === option.value

                    return (
                        <Button
                            key={option.value}
                            variant="default"
                            aria-label={option.label}
                            aria-pressed={selected}
                            className={selected ? classes.active : classes.inactive}
                            style={selected ? selectedButtonStyle : undefined}
                            px="sm"
                            onClick={() => onChange(option.value)}
                        >
                            {boardLayoutIcon(option.value, selected)}
                        </Button>
                    )
                })}
            </Button.Group>
        </div>
    )
}
